import { useEffect, useState, useCallback } from "react";
import { useNotifications } from "./useNotifications";

export interface NetworkStatus {
  isOnline: boolean;
  wasOffline: boolean;
}

export const useNetworkStatus = () => {
  const { addSuccess, addWarning } = useNotifications();
  const [networkStatus, setNetworkStatus] = useState<NetworkStatus>({
    isOnline: navigator.onLine,
    wasOffline: false,
  });

  const handleOnline = useCallback(() => {
    console.log("🌐 Conexão restaurada");
    setNetworkStatus((prev) => {
      const wasOffline = !prev.isOnline;
      if (wasOffline) {
        addSuccess("🌐 Conexão restaurada. Sincronização será retomada.");
      }
      return { isOnline: true, wasOffline };
    });
  }, [addSuccess]);

  const handleOffline = useCallback(() => {
    console.log("📵 Sem conexão com a internet");
    setNetworkStatus({ isOnline: false, wasOffline: false });
    addWarning("📵 Sem conexão. Sincronização pausada.");
  }, [addWarning]);

  useEffect(() => {
    // Listeners de eventos de rede
    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    // Verificação inicial
    if (!navigator.onLine) {
      setNetworkStatus({ isOnline: false, wasOffline: false });
    }

    // Cleanup
    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, [handleOnline, handleOffline]);

  return networkStatus;
};

export default useNetworkStatus;
